import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function Footer() {
  const { settings } = useApp();
  const s = settings || {};
  const phone = s.phone || "8879874738";
  const whatsapp = s.whatsapp || "8879874738";
  const email = (s.email || "StreetAutoMumbai@gmail.com").replace(/@google\.com$/i, "@gmail.com");
  const address = s.address || "Mumbai, India";

  return (
    <footer data-testid="site-footer" className="bg-[#050505] border-t border-white/10 pt-16 md:pt-24 pb-8 mt-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            {s.logo_url ? (
              <div className="inline-flex bg-white px-3 py-2 mb-4"><img src={s.logo_url} alt="Street Auto Accessories" className="h-12 w-auto" /></div>
            ) : (
              <>
                <div className="font-display text-2xl leading-none mb-3">STREET AUTO<span className="text-[#E63946]">.</span></div>
                <div className="overline text-white/50 mb-4">{s.brand_suffix || "ACCESSORIES"}</div>
              </>
            )}
            <p className="text-sm text-white/60 leading-relaxed max-w-xs">
              {s.tagline || "Modify, Personalize, Elevate."} — Premium automotive accessories for every drive.
            </p>
            <div className="flex gap-3 mt-6">
              <a href={`https://instagram.com/${(s.instagram || "").replace("@","")}`} target="_blank" rel="noreferrer" className="w-10 h-10 border border-white/15 hover:border-[#E63946] hover:text-[#E63946] flex items-center justify-center" aria-label="Instagram">
                <Instagram size={18} />
              </a>
              <a href={`https://wa.me/91${whatsapp}`} target="_blank" rel="noreferrer" className="w-10 h-10 border border-white/15 hover:border-[#E63946] hover:text-[#E63946] flex items-center justify-center" aria-label="WhatsApp">
                <MessageCircle size={18} />
              </a>
            </div>
          </div>

          <div>
            <div className="overline text-white/50 mb-4">Shop</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/collection/interior-accessories" className="text-white/80 hover:text-white">Interior Accessories</Link></li>
              <li><Link to="/collection/exterior-accessories" className="text-white/80 hover:text-white">Exterior Accessories</Link></li>
              <li><Link to="/collection/lights-electronics" className="text-white/80 hover:text-white">Lights & Electronics</Link></li>
              <li><Link to="/collection/car-care" className="text-white/80 hover:text-white">Car Care</Link></li>
              <li><Link to="/collection/performance-styling" className="text-white/80 hover:text-white">Performance & Styling</Link></li>
              <li><Link to="/collection/utility-convenience" className="text-white/80 hover:text-white">Utility & Convenience</Link></li>
              <li><Link to="/collection/new-arrivals" className="text-white/80 hover:text-white">New Arrivals</Link></li>
              <li><Link to="/collection/best-sellers" className="text-white/80 hover:text-white">Best Sellers</Link></li>
              <li><Link to="/collection/deals" className="text-white/80 hover:text-white">Deals</Link></li>
            </ul>
          </div>

          <div>
            <div className="overline text-white/50 mb-4">Help</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="text-white/80 hover:text-white">Contact Us</Link></li>
              <li><Link to="/ask-expert" className="text-white/80 hover:text-white">Ask an Expert</Link></li>
              <li><Link to="/policies/shipping" className="text-white/80 hover:text-white">Shipping Information</Link></li>
              <li><Link to="/policies/order-issues" className="text-white/80 hover:text-white">Order Issues</Link></li>
              <li><Link to="/policies/privacy" className="text-white/80 hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/policies/terms" className="text-white/80 hover:text-white">Terms & Conditions</Link></li>
            </ul>
          </div>

          <div>
            <div className="overline text-white/50 mb-4">Support</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2"><Phone size={14} className="mt-1 text-[#E63946]"/> {phone}</li>
              <li className="flex items-start gap-2"><MessageCircle size={14} className="mt-1 text-[#E63946]"/> WhatsApp: {whatsapp}</li>
              <li className="flex items-start gap-2"><Mail size={14} className="mt-1 text-[#E63946]"/> <span className="break-all">{email}</span></li>
              <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 text-[#E63946]"/> {address}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Street Auto Accessories. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <span>Secure Payment</span>
            <span>•</span>
            <span>Pan-India Delivery</span>
            <span>•</span>
            <span>{s.shipping_estimate_days || "3–7 working days"}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
